import { checkClickBuyer } from '../PermissionsWrappers/permissionChecks';

export const formatAffiliateLabel = (affiliateId, affiliateName) => {
  if (checkClickBuyer() || !affiliateName) {
    return `${affiliateId}`;
  }

  return `${affiliateName} (#${affiliateId})`;
};
